export const status = [
  { id: 'free', name: 'FREE' },
  { id: 'paid', name: 'PAID' },
];
